import { FileUploadConfig } from '../constants';

// TODO UPLOADS: consider trimming the restrictions to what is being used
/* eslint-disable @typescript-eslint/no-use-before-define */
export type UploaderRestrictions = {
  maxFileSize: null | number;
  minFileSize: null | number;
  maxTotalFileSize: null | number;
  maxNumberOfFiles: null | number;
  minNumberOfFiles: null | number;
  allowedFileTypes: null | string[];
  requiredMetaFields: string[];
  mixedMediaError?: string;
  uploadConfig: FileUploadConfig;
};

export const UploaderRestrictions = {
  new(
    fileRestrictions: Partial<UploaderRestrictions> = {}
  ): UploaderRestrictions {
    return {
      ...defaultRestrictions(),
      ...fileRestrictions,
    };
  },
};

function defaultRestrictions(): UploaderRestrictions {
  return {
    maxFileSize: null,
    minFileSize: null,
    maxTotalFileSize: null,
    maxNumberOfFiles: null,
    minNumberOfFiles: null,
    allowedFileTypes: allowedFileTypes(),
    requiredMetaFields: [],
    uploadConfig: FileUploadConfig.MEDIA,
  };
}

/**
 * Allowed in the backend
 * @see https://github.com/bufferapp/buffer-web/blob/main/shared/helpers/utils_helper.php#L983
 */
function allowedFileTypes(): string[] {
  return [
    'm4v',
    'mov',
    'mp4',
    'avi',
    'webm',
    'jpg',
    'jpeg',
    'png',
    'gif',
    'webp',
  ].map((ext) => `.${ext}`);
}
